exelare_jobs.define('noconflict',["jquery"], function ($) {
    return $.noConflict(true);
});
